import { useState } from "react";
import { NormalContainerWithHeader } from "../../shared/components/student/NormalComponent"
import SelectBoxField from "../../shared/components/formfields/SelectBoxField";
import { Box, Button, Grid2, Typography, IconButton, RadioGroup, Radio, FormControlLabel, } from "@mui/material";
import CustomDivider from "../../shared/utils/CustomDivider";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { Grid_Gap } from '../../shared/constants';
import { useToaster } from '../../shared/utils/ToasterProvider';
import { IdAutoCompleteField } from '../../shared/components/formfields/IdAutoCompleteField';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import useAuthStore from '../../store/useAuthStore';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDialog } from "../../shared/hook/useDialog";
import MainDialogBox from "../../shared/components/Dialog/MainDialogBox";
import { useTrainerOptions } from "./option/TrainerOption";
import { useCourseOptions } from "./option/CourseOption";
import { useApartmentNodeOptions } from "./option/ApartmenNodeOption";
import { useBatchNodeOptions } from "./option/BatchOption";
import { postAssignTrainer } from "../../assets/nodeApi/postApi/postAdminApi";
import { useTrainerTimeTable } from "../../assets/api/useAdminApi";
import api from "../../assets/nodeApi/axiosInstance";
import { SlotCard, TimeSlotChip } from "../student/StudentOnlineCourseDetail";
import { formatToAmPm, formatToYYYYMMDD } from "../../shared/formatter";
import DataGridSkeleton from "../../shared/components/DataGridSkeleton";


function EntryCell({ entry, day, onDelete }) {

  const { open, handleClickOpen, handleClose } = useDialog();
  const { showToaster } = useToaster();
  const queryClient = useQueryClient();
  const { token } = useAuthStore()
  const [showDelete, setShowDelete] = useState(false);

  const handleDoubleClick = () => {
    if (entry) {
      setShowDelete(true);
    }
  };

  const handleDelete = () => {
    if (onDelete) onDelete(entry);
    handleClickOpen()
  };

  const mutationDeleteSlot = useMutation({
    mutationFn: ({ path, data }) =>
      api.post(path, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
  });

  const handleDeleteOSlot = () => {

    const isOnline = entry?.type === 'online' || entry?.type === 8; // adjust if needed

    const path = isOnline
      ? 'trainer/remove-online-assignments'
      : 'trainer/remove-offline-assignments';

    const data = {
      trainer_id: entry?.trainer_id,
      assignments: [
        {
          course_id: entry?.course_id,
          ...(isOnline
            ? { batch_names: [entry?.batch_name] }
            : { apartment_ids: [entry?.apartments_id] }),
        },
      ],
    };

    mutationDeleteSlot.mutate(
      { path, data },
      {
        onSuccess: () => {
          showToaster('Slots Removed', 'Slots Removed Successfully', 'success');
          handleClose()
          queryClient.invalidateQueries({ queryKey: ['trainer-schedules'] });
          setShowDelete(false);
        },
        onError: () => {
          showToaster('Something went wrong', 'Error', 'error');
        },
      }
    );
  };


  return (
    <>
      <TableCell
        key={day}
        sx={{
          height: 60,
          textAlign: "center",
          border: "1px solid #4169E1",
          cursor: entry ? "pointer" : "default",
        }}
        onDoubleClick={entry ? handleDoubleClick : undefined}
      >
        {entry && (
          <>
            <Box sx={{ display: "flex", justifyContent: "end" }}>
              {showDelete && (
                <IconButton onClick={handleDelete}><DeleteIcon fontSize="12px" /></IconButton>
              )}
            </Box>
            <>
              <Typography variant="body2">{entry.course_title}</Typography>
              <Typography variant="body2">{entry?.type === "online" ? entry?.batch_name : entry.apartment_name}</Typography>
              <Typography variant="body2" fontSize="11px">
                {entry.batch_start_date} - {entry.batch_end_date}
              </Typography>
            </>
          </>
        )}
      </TableCell>
      <MainDialogBox open={open} handleClose={handleClose} width={"40%"}>
        <Typography my={3}>Are you Sure You want delete this slot</Typography>
        <Grid2 container sx={{ display: "flex", justifyContent: "end" }} spacing={Grid_Gap}>
          <Grid2 children size={4}>
            <Button variant="outlined" fullWidth onClick={handleClose}>Cancel</Button>
          </Grid2>
          <Grid2 children size={4}>
            <Button variant="contained" fullWidth onClick={handleDeleteOSlot}>Delete</Button>
          </Grid2>
        </Grid2>
      </MainDialogBox>

    </>
  );
}


const AssignTrainer = () => {
  const { showToaster } = useToaster();
  const [trainerId, setTrainerId] = useState(null)
  const queryClient = useQueryClient();
  const { data: timetable, isLoading: isTimeTableLoading } = useTrainerTimeTable({ trainer_id: trainerId });
  const [selectedCourse, setSelectedCourse] = useState({})
  const [selectedApart, setSelectedApart] = useState([])
  const [selectedOnlineCourse, setSelectedOnlineCourse] = useState({})
  const { AllTrainer } = useTrainerOptions()
  const [selectedTrainer, setSelectedTrainer] = useState({})
  const { AllCourses } = useCourseOptions(trainerId)
  const { ApartmentForCourse } = useApartmentNodeOptions(trainerId, selectedCourse?.id)
  const { BatchForCourse } = useBatchNodeOptions(trainerId, selectedOnlineCourse?.id)

  const handleChangeTrainer = (value) => {
    setTrainerId(value)
    setSelectedApart({})
    setSelectedCourse({})
    setSelectedBatch({})
    setSelectedTrainer({})
  };

  const pretty = (t) => {
    const [h, m] = t.split(":").map(Number);
    const period = h >= 12 ? "PM" : "AM";
    const hour12 = h % 12 === 0 ? 12 : h % 12;
    return `${hour12?.toString()?.padStart(2, "0")}:${m?.toString()?.padStart(2, "0")} ${period}`;
  };

  const days = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const timeSlots = Array.from(
    new Set(
      timetable?.map(
        (s) => `${s?.start_time}–${s?.end_time}`
      )
    )
  ).sort()

  const mutationAssignTrainer = useMutation({
    mutationFn: ({ id, formData }) => postAssignTrainer(id, formData),
  });

  const handleSubmitTrainer = (values, { resetForm }) => {
    const { apartment_id, ...restValues } = values;
    const obj = {
      class_type: "offline",
      apartment_ids: selectedApart?.apartment_id
        ? [selectedApart.apartment_id]
        : [],
      ...restValues

    }

    mutationAssignTrainer.mutate({ id: trainerId, formData: obj }, {
      onSuccess: (response) => {
        try {
          showToaster('Success', response?.data?.message, 'success');
          setSelectedApart({});
          // setTrainerId(null);
          setSelectedCourse("")
          resetForm();

          queryClient.invalidateQueries({ queryKey: ['trainer-schedules'] });
        } catch (err) {
          console.error("Error inside onSuccess", err);
        }
      },
      onError: () => {
        showToaster("Something went wrong", 'Error', 'error');
      }
    });
  }
  const offlineComponent = () => {
    return (
      <Formik
        enableReinitialize
        initialValues={{
          course_id: null,
          apartment_id: null,
        }}
        validationSchema={Yup.object().shape({
          course_id: Yup.string()
            .nullable()
            .required("Course is required"),

        })}
        onSubmit={handleSubmitTrainer}

      >
        {({ resetForm, setFieldValue }) => (
          <Form>
            <Typography variant="h5" mb={3}>Assign course and choose Apartment accordingly </Typography>
            <Grid2 container spacing={"30px"}>
              <Grid2 children size={{ xs: 12, sm: 4 }}>
                <Field
                  name="course_id"
                  component={IdAutoCompleteField}
                  options={AllCourses.offlineOptions}
                  label="Courses"
                  isRequired={true}
                  isLoading={AllCourses.isLoading}
                  onValueChange={(newValue) => {
                    setSelectedCourse(newValue)
                    setSelectedApart({})
                    setFieldValue("apartment_id", "")
                  }}
                />
              </Grid2>
              <Grid2 children size={{ xs: 12, sm: 4 }}>
                <Field
                  name="apartment_id"
                  component={IdAutoCompleteField}
                  options={ApartmentForCourse.options}
                  noOptionsText={"No Apartment Found"}
                  label="Apartments"
                  isRequired={true}
                  isLoading={ApartmentForCourse.isLoading}
                  onValueChange={(newValue) => {
                    setSelectedApart(newValue);
                  }}
                />
              </Grid2>

              <Grid2 children size={12}>

                {
                  selectedApart?.apartment_id &&
                  <Grid2 children size={{ xs: 12, sm: 6 }}>
                    <Box sx={{ display: "flex", gap: 2 }}>
                      <Typography> Start Date : {formatToYYYYMMDD(selectedApart?.start_date)}</Typography>
                      <Typography> End Date : {formatToYYYYMMDD(selectedApart?.end_date)}</Typography>
                    </Box>
                    {selectedApart?.timings?.map((item, index) => (
                      <SlotCard day={item?.day} timing={`${formatToAmPm(item?.start_time)}-${formatToAmPm(item?.end_time)}`} key={index} />
                    ))}
                  </Grid2>
                }

              </Grid2>
            </Grid2>
            <CustomDivider />
            <Grid2 container sx={{ display: "flex", justifyContent: "flex-end", gap: Grid_Gap }}>
              <Grid2 children textAlign={"end"} size={3} >
                <Button
                  variant='outlined'
                  type="button"
                  onClick={() => { resetForm(); setTrainerId(null); }}
                  fullWidth
                  disabled={mutationAssignTrainer.isPending}
                >
                  Reset
                </Button>
              </Grid2>
              <Grid2 children textAlign={"end"} size={3} >
                <Button
                  variant='contained'
                  type='submit'
                  fullWidth
                  disabled={mutationAssignTrainer.isPending}
                >
                  {mutationAssignTrainer.isPending ? "Submitting" : "Submit"}
                </Button>
              </Grid2>
            </Grid2>
          </Form>
        )}
      </Formik>
    )
  }
  const [selectedBatch, setSelectedBatch] = useState({})




  const handleSubmitOnlineBatch = (values, { resetForm }) => {

    const obj = {
      class_type: "online",
      ...values
    }

    mutationAssignTrainer.mutate({ id: trainerId, formData: obj }, {
      onSuccess: (response) => {
        try {
          showToaster('Success', response?.data?.message, 'success');
          queryClient.invalidateQueries({ queryKey: ['trainer-schedules'] });
          resetForm();
          setSelectedOnlineCourse("");
          // setTrainerId(null);
          setSelectedBatch({})
          // setSelectedTrainer({})
        } catch (err) {
          console.error("Error inside onSuccess", err);
        }
      },
      onError: (error) => {
        showToaster(error?.response?.data?.message, 'Error', 'error');
      }
    });

  }

  const onlineComponent = () => {
    return (
      <Formik
        enableReinitialize

        initialValues={{
          course_id: null,
          batch_id: null,
        }}

        validationSchema={Yup.object().shape({
          course_id: Yup.string()
            .nullable()
            .required("Course is required"),

          batch_id: Yup.string()
            .nullable()
            .required("Batch is required"),

        })}

        onSubmit={handleSubmitOnlineBatch}>

        {({ resetForm, setFieldValue }) => (
          <Form>
            <Typography variant="h5" mb={3}>Assign course and choose batch accordingly </Typography>
            <Grid2 container spacing={"30px"}>

              <Grid2 children size={{ xs: 12, sm: 4 }}>
                <Field
                  name="course_id"
                  component={IdAutoCompleteField}
                  options={AllCourses.onlineOptions}
                  label="Courses"
                  isRequired={true}
                  isLoading={AllCourses.isLoading}
                  onValueChange={(newValue) => {
                    setSelectedOnlineCourse(newValue)
                    setSelectedBatch([])
                    setFieldValue("batch_id", "")
                  }}
                />
              </Grid2>
              <Grid2 children size={{ xs: 12, sm: 4 }}>
                <Field
                  name="batch_id"
                  component={IdAutoCompleteField}
                  options={BatchForCourse.options}
                  noOptionsText={"No Batch Found"}
                  label="Batches"
                  isRequired={true}
                  isLoading={BatchForCourse.isLoading}
                  onValueChange={(newValue) => {
                    setSelectedBatch(newValue);

                  }}
                />
              </Grid2>
              {
                selectedBatch?.id &&

                <Grid2 children size={{ xs: 12, sm: 6 }}>
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <Typography> Start Date : {formatToYYYYMMDD(selectedBatch?.start_date)}</Typography>
                    <Typography> End Date : {formatToYYYYMMDD(selectedBatch?.end_date)}</Typography>
                  </Box>

                  {selectedBatch?.sessions?.map((item, index) => (
                    <SlotCard day={item?.day} timing={`${formatToAmPm(item?.slots?.start_time)}-${formatToAmPm(item?.slots?.end_time)}`} key={index} />
                  ))}
                </Grid2>
              }

            </Grid2>
            <CustomDivider />
            <Grid2 container sx={{ display: "flex", justifyContent: "flex-end", gap: Grid_Gap }}>
              <Grid2 children textAlign={"end"} size={3} >
                <Button
                  variant='outlined'
                  type="button"
                  onClick={() => { resetForm(); setSelectedBatch([]); setSelectedOnlineCourse({}) }}
                  fullWidth
                  disabled={mutationAssignTrainer.isPending}
                >
                  Reset
                </Button>
              </Grid2>
              <Grid2 children textAlign={"end"} size={3} >
                <Button
                  variant='contained'
                  type='submit'
                  fullWidth
                  disabled={mutationAssignTrainer.isPending}
                >
                  {mutationAssignTrainer.isPending ? "Submitting" : "Submit"}

                </Button>
              </Grid2>
            </Grid2>
          </Form>
        )}
      </Formik>
    )
  }

  const optionsList = [
    { label: "Offline", value: "offline" },
    { label: "Online", value: "online" },
  ];

  const [selectedOption, setSelectedOption] = useState("offline");

  const renderSelectedComponent = () => {
    switch (selectedOption) {
      case "online":
        return onlineComponent();
      case "offline":
        return offlineComponent();
      default:
        return null;
    }
  };

  return (
    <>
      <NormalContainerWithHeader headerText={"Assign Trainer"}>
        <Grid2 container spacing={"1rem"}>
          <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
            <SelectBoxField
              label="Select Trainer"
              options={AllTrainer.options}
              isRequired={true}
              onChange={handleChangeTrainer}
              isloading={AllTrainer.isLoading}
              value={trainerId}
              onChangeValue={(value) => {
                setSelectedTrainer(value)
              }}


            />
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 6, md: 8 }}>




            {
              selectedTrainer?.id && <>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Typography>Preferred Subjects : </Typography>
                  {
                    selectedTrainer?.preferred_subjects?.map((item, index) => (
                      <Typography>{item}</Typography>
                    ))
                  }
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Typography>Preferred Zone : </Typography>
                  {
                    selectedTrainer?.preferred_zone_name?.map((item, index) => (
                      <Typography>{item}</Typography>
                    ))
                  }
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Typography>Working Days : </Typography>
                  {
                    selectedTrainer?.working_days?.map((item, index) => (
                      <Typography>{item}</Typography>
                    ))
                  }
                </Box>
              </>
            }

          </Grid2>
        </Grid2>
        <CustomDivider />
        <TableContainer
          sx={{
            mx: "auto",
            boxShadow: "none",
            border: "1px solid #4169E1",
            overflowX: "auto",
            overflowY: "hidden",
            whiteSpace: "nowrap",
            "&::-webkit-scrollbar": {
              height: "8px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#888",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#f1f1f1",
            },
          }}
        >

          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    width: 110,
                    textAlign: "center",
                    border: "1px solid #4169E1",
                  }}
                >
                  Time Table
                </TableCell>
                {days.map((d) => (
                  <TableCell
                    key={d}
                    sx={{
                      color: "blue.main",
                      textAlign: "center",
                      border: "1px solid #4169E1",

                    }}
                  >
                    {d}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            {!isTimeTableLoading && <TableBody>
              {timeSlots.map((slot) => {
                const [start, end] = slot?.split("–");

                return (
                  <TableRow key={slot}>
                    <TableCell
                      sx={{
                        height: 60,
                        textAlign: "center",
                        fontWeight: 500,
                        border: "1px solid #4169E1",
                        color: "blue.main"
                      }}
                    >
                      {pretty(start)} – {pretty(end)}
                    </TableCell>
                    {days.map((day) => {
                      const entry = timetable?.find(
                        (s) =>
                          s?.day === day &&
                          s?.start_time === start &&
                          s?.end_time === end
                      );

                      return (
                        <EntryCell
                          entry={entry}
                          day={day}
                          onDelete={(entry) => {
                            console.log("Delete this entry:", entry);
                          }}
                        />
                      );
                    })}

                  </TableRow>
                );
              })}
            </TableBody>}


          </Table>
        </TableContainer>
        {isTimeTableLoading &&
          <Box>
            <DataGridSkeleton rowsNum={5} />
          </Box>
        }
        <CustomDivider />


        <Typography variant="h5" mb={2}>Choose the type of class to assign</Typography>

        <RadioGroup
          row
          value={selectedOption}
          onChange={(e) => { setSelectedOption(e.target.value); setSelectedApart([]); setSelectedBatch([]) }}

        >
          {optionsList.map(option => {
            return (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={
                  <Radio
                    sx={{
                      color: "#4169E1",
                      '&.Mui-checked': {
                        color: "#4169E1",
                      },
                    }}
                  />
                }
                label={<Typography variant='body2' fontSize={{ xs: "10px", sm: "16px" }}>{option.label}</Typography>}
              />
            );
          })}
        </RadioGroup>
        <CustomDivider />
        {renderSelectedComponent()}
      </NormalContainerWithHeader >

    </>
  )
}

export default AssignTrainer





